import { IonContent, IonPage } from '@ionic/react';
import React, { useContext } from 'react';
import { useParams } from 'react-router';
import { ExpertShow } from '../components/experts';
import { MenuBar } from '../components/layout';
import { TranslationContext } from '../contexts';

export const ExpertPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { translate } = useContext(TranslationContext);

  return (
    <IonPage>
      <MenuBar backLink="/customer/expert" title={translate('experts.title')} />
      <IonContent className="ion-padding">
        <ExpertShow id={id!} />
      </IonContent>
    </IonPage>
  );
};
